import React from 'react';
import moment from "moment";

import Stars from '../../../../../Common/Stars';
import { DivisionIcon, VCIcon } from '../../../../../Common/Buttons/TypeIcons';
import { Heading6, CaptionMedium, P3Bold } from '../../../../../Common/DesignSystem/Text';
import Button from '../../../../../Common/DesignSystem/Button';
import colours from '../../../../../Common/DesignSystem/Colours';
import Icon from '../../../../../Common/DesignSystem/Icons/Icon';

export const VehicleSettingsCard = ({ vehicle, editVehicle, toInputRef, match }) => {
	const iconContainerStyle = { marginRight: 8, borderRadius: '8px', color: colours.primary.blue, backgroundColor: colours.functional.hover_secondaryblue };

	const getUsage = (vehicle) => {
        if (vehicle.active) {
			if ((vehicle.status === 'active')) {
                return (
                    <div style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                        <Icon name="UsageActive" size={24} style={{marginRight: 4, color: colours.accent.validate_green}}/>
                        <P3Bold style={{margin: "0 10px 0 0", padding: 0}}>Active</P3Bold>
                    </div>
                )
            }

			if(moment(vehicle.availableAt, "YYYY-MM-DD").startOf('day').isBefore(moment().subtract(90, 'days').startOf('day'))) {
				return(
                    <div style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                        <Icon name="UsageInactive" size={24} style={{marginRight: 4, color: colours.accent.error_red}}/>
                        <P3Bold style={{margin: "0 10px 0 0", padding: 0}}>Inactive</P3Bold>
                    </div>
                )
            }
        }

        return (
            <div style={{display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center'}}>
                <Icon name="Minus" size={24} style={{marginRight: 4, color: colours.primary.grey04}}/>
                <P3Bold style={{margin: "0 10px 0 0", padding: 0}}>No Activity</P3Bold>
            </div>
        )
    }

	return (
		<div className="overlay_header_bordered" style={{marginTop: 16}}>
			<div className="profile-info-container">
				<div style={{justifyContent: 'space-between', flexDirection: 'row', display: 'flex', flex: 1}}>
					<Heading6 style={{color: colours.primary.grey01}}>Vehicle Settings</Heading6>
					<Button small tertiary label="Edit" leading_ic="Edit" color={colours.primary.grey02} onClick={editVehicle}/>
				</div>
			</div>
			<div style={{display: 'flex', flexDirection: 'row', flex: 2}}>
				<div style={{display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'flex-start', paddingRight: 8, borderRight: `solid 1px ${colours.primary.grey04}`}}>
					<div style={{marginTop: 16, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center'}}>
						<div>
							<div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', height: 30}}>
								<CaptionMedium style={{color: colours.primary.grey02}}>Usage:</CaptionMedium>
							</div>
							<div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 4, height: 30}}>
								<CaptionMedium style={{color: colours.primary.grey02}}>Tier:</CaptionMedium>
							</div>
							<div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 4, height: 30}}>
								<CaptionMedium style={{color: colours.primary.grey02}}>Facility:</CaptionMedium>
							</div>
							<div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 4, height: 30}}>
								<CaptionMedium style={{color: colours.primary.grey02}}>Pool:</CaptionMedium>
							</div>
						</div>
						<div style={{marginRight: 8}}>
							<div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', height: 30}}>
								<P3Bold>
									{getUsage(vehicle)}
								</P3Bold>
							</div>
							<div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 4, height: 30}}>
								{vehicle.tier && (
									<Stars star={vehicle.tier} type={"Vehicle"} ID={match.params.v_id}/>
								)}
							</div>
							<div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 4, height: 30}}>
								<div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>
									{/* missing data in gql */}
									{VCIcon(vehicle.vmh, null, null, null, true)}
									<P3Bold>{vehicle?.vmh?.Display_Name + " - " + vehicle?.vmh?.Display_City}</P3Bold>
								</div>
							</div>
							<div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 4, height: 30}}>
								<div className="overlay_header_info_access_item" style={{alignItems: 'center'}}>
									{/* missing data in gql */}
									{DivisionIcon(vehicle.stakeholder, null, null, null, true)}
									<P3Bold style={{marginLeft: -2}}>{vehicle?.stakeholder?.Division} Division</P3Bold>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div style={{display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'flex-start', marginLeft: 8}}>
					<div style={{marginTop: 16, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'space-between', alignItems: 'center'}}>
						<div>
							<div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', height: 30}}>
								<Icon size={24} name="Warranty" style={iconContainerStyle} />
								<CaptionMedium style={{color: colours.primary.grey02}}>Warranty Start:</CaptionMedium>
							</div>
							<div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 8, height: 30}}>
								<Icon size={24} name="AvailableDate" style={iconContainerStyle} />
								<CaptionMedium style={{color: colours.primary.grey02}}>Available Date:</CaptionMedium>
							</div>
							<div style={{flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 8, height: 30}}>
								<Icon size={24} name="RetireDate" style={iconContainerStyle} />
								<CaptionMedium style={{color: colours.primary.grey02}}>Retire Date:</CaptionMedium>
							</div>
						</div>
						<div>
							<div style={{height: 24, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', height: 30}}>
								<P3Bold>
									{vehicle.warrantyDate ? (
										moment(vehicle.warrantyDate).format('MMM DD, YYYY')
									) : (
										<Button
											small
											tertiary
											label="Add Warranty Start Date"
											onClick={() => {
												editVehicle();
												toInputRef('warrantyDateRef');
											}}
											leading_ic="AddCircle"
											style={{padding: 0}}
										/>
									)}
								</P3Bold>
							</div>
							<div style={{height: 24, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 8, height: 30}}>
								<P3Bold>
									{vehicle.availableAt ? (
										moment(vehicle.availableAt).format('MMM DD, YYYY')
									) : (
										<Button
											small
											tertiary
											label="Add Available Date"
											onClick={() => {
												editVehicle();
												toInputRef('availableDateRef');
											}}
											leading_ic="AddCircle"
											style={{padding: 0}}
										/>
									)}
								</P3Bold>
							</div>
							<div style={{height: 24, flexDirection: 'row', display: 'flex', flex: 1, justifyContent: 'flex-start', alignItems: 'center', marginTop: 8, height: 30}}>
								<P3Bold>
									{vehicle.scheduledTerminatedAt ? (
										moment(vehicle.scheduledTerminatedAt).format('MMM DD, YYYY')
									) : (
										<Button
											small
											tertiary
											label="Add Retire Date"
											onClick={() => {
												editVehicle();
												toInputRef('retireDateRef');
											}}
											leading_ic="AddCircle"
											style={{padding: 0}}
										/>
									)}
								</P3Bold>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}